// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { AbstractQueryParams, TypesaurusCoreDoc } from '@res/ngg-core';
import { CompanyModel } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace CompanyActions {
  export class GetAllCompany {
    static readonly type = '[Company] GetAllUser';
    readonly type = GetAllCompany.type;
  }

  export class GetCompanyById {
    static readonly type = '[Company] GetUserById';
    readonly type = GetCompanyById.type;
  }

  export class UpdateCompany {
    static readonly type = '[Company] UpdateUser';
    readonly type = UpdateCompany.type;
  }

  export class UpdateCompanyResult {
    static readonly type = '[Company] UpdateCompanyResult';
    constructor(public data: Array<TypesaurusCoreDoc<CompanyModel> | null | undefined>) {}
  }

  export class DeleteCompany {
    static readonly type = '[Company] DeleteUser';
    readonly type = DeleteCompany.type;
  }

  export class QueryCompany {
    static readonly type = '[Company] QueryUser';

    constructor(
      public filter: {
        query: AbstractQueryParams<CompanyModel>[];
      },
    ) {}
  }
}
